@if (loading) {
  <div class="skeleton-wrapper" [ngClass]="{ 'med_connectors-list-wrapper-mobile': !deviceType.isDesktop }">
    <div class="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
      <div class="flex-grow-1">
        <p-skeleton width="20%" height="1.1rem" styleClass="mb-2" borderRadius="10px" />
        <p-skeleton width="50%" height="1.1rem" styleClass="mb-2" borderRadius="10px" />
      </div>
      <p-skeleton width="6rem" height="1.6rem" borderRadius="20px" />
    </div>
    <p-skeleton width="25%" height="1.1rem" styleClass="mb-3" borderRadius="10px" />

    <div class="w-100 h-100 min-vh-100" #placeholderWrapper>
      @if (placeholderItems > 0) {
        @for (item of [].constructor(placeholderItems); let i = $index; track $index) {
          <div class="row" #placeHolderItem>
            <div class="col-12 col-sm-6 col-md-4 col-xxl-3">
              <div class="card p-3 w-100 mb-4">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="result_source_icon mb-1">
                    <img src="assets/images/medullar_logo_skeleton.svg" alt="medullar logo" />
                  </div>
                  <app-icon icon="ellipsis-vertical" class="icon-skeleton" />
                </div>
                <div class="d-flex justify-content-between align-items-end">
                  <div class="flex-grow-1">
                    <p-skeleton width="80%" height="1.1rem" styleClass="mb-2" borderRadius="10px" />
                    <p-skeleton width="60%" height="1.1rem" borderRadius="10px" />
                  </div>
                  <p-skeleton width="2.6rem" height="1.6rem" borderRadius="20px" />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-xxl-3">
              <div class="card p-3 w-100 mb-4">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="result_source_icon mb-1">
                    <img src="assets/images/medullar_logo_skeleton.svg" alt="medullar logo" />
                  </div>
                  <app-icon icon="ellipsis-vertical" class="icon-skeleton" />
                </div>
                <div class="d-flex justify-content-between align-items-end">
                  <div class="flex-grow-1">
                    <p-skeleton width="80%" height="1.1rem" styleClass="mb-2" borderRadius="10px" />
                    <p-skeleton width="60%" height="1.1rem" borderRadius="10px" />
                  </div>
                  <p-skeleton width="2.6rem" height="1.6rem" borderRadius="20px" />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-xxl-3">
              <div class="card p-3 w-100 mb-4">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="result_source_icon mb-1">
                    <img src="assets/images/medullar_logo_skeleton.svg" alt="medullar logo" />
                  </div>
                  <app-icon icon="ellipsis-vertical" class="icon-skeleton" />
                </div>
                <div class="d-flex justify-content-between align-items-end">
                  <div class="flex-grow-1">
                    <p-skeleton width="80%" height="1.1rem" styleClass="mb-2" borderRadius="10px" />
                    <p-skeleton width="60%" height="1.1rem" borderRadius="10px" />
                  </div>
                  <p-skeleton width="2.6rem" height="1.6rem" borderRadius="20px" />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-xxl-3">
              <div class="card p-3 w-100 mb-4">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="result_source_icon mb-1">
                    <img src="assets/images/medullar_logo_skeleton.svg" alt="medullar logo" />
                  </div>
                  <app-icon icon="ellipsis-vertical" class="icon-skeleton" />
                </div>
                <div class="d-flex justify-content-between align-items-end">
                  <div class="flex-grow-1">
                    <p-skeleton width="80%" height="1.1rem" styleClass="mb-2" borderRadius="10px" />
                    <p-skeleton width="60%" height="1.1rem" borderRadius="10px" />
                  </div>
                  <p-skeleton width="2.6rem" height="1.6rem" borderRadius="20px" />
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
}

<app-header-bar [ngClass]="{ 'med_hidden-connector': loading }">
  <ng-container header-left>
    <div class="d-flex flex-column align-items-start" [ngClass]="{ isMobile: !deviceType.isDesktop }">
      <h1 class="s-title bold" data-cy="med_connectors_title">{{ "my_connectors" | translate | titlecase }}</h1>
      <p class="m-body">{{ "my_connectors_description" | translate }}</p>
    </div>
  </ng-container>
  <ng-container header-right>
    <!-- DESKTOP MENU -->
    @if (deviceType.isDesktop) {
      <div class="sort_select_wrapper">
        <button
          class="med_sort-btn w-auto border-0 rounded-pill l-body d-flex justify-content-between align-items-center text-capitalize gap-2 py-0 pe-2 ps-3"
          mat-button
          data-cy="med_connectors_toggle_connector_trigger_btn"
          [matMenuTriggerFor]="belowMenu"
        >
          <div class="d-flex justify-content-start align-items-center gap-2">
            <app-icon icon="filter" class="icon-active"></app-icon>
            <span class="l-body">{{ selectedFilter | translate }} </span>
          </div>

          <app-icon icon="chevron-down" />
        </button>
        <mat-menu
          #belowMenu="matMenu"
          yPosition="below"
          class="med_filter-drowpdown d-flex flex-column align-itmes-start mt-1"
        >
          @for (option of myAppsStore.connectorFilterMenu(); let i = $index; track $index) {
            <button
              class="med_btn-option med_justify-content-between"
              [ngClass]="{ active: option.checked }"
              mat-menu-item
              [attr.data-cy]="'med_connector_sort_option_' + option.name"
              (click)="toggleConnectorFilter(option.name)"
            >
              <div class="d-flex justify-content-start align-items-center">
                <p class="l-body m-0">{{ option.label }}</p>
              </div>
              <p class="xs-body secondary-color ps-1 text-nowrap my-0 ms-2">
                {{ myAppsStore.getSelectedFilterCount(option.name) }} / {{ myAppsStore.allConnectors().length }}
              </p>
            </button>
          }
        </mat-menu>
      </div>
    }
    @if (deviceType.isDesktop) {
      <div class="d-flex justify-content-end align-items-center gap-3">
        <div class="input-group med_search">
          <span class="input-group-text border-0">
            <app-icon icon="magnifying-glass" />
          </span>
          <input
            type="text"
            class="form-control border-0 ps-0"
            placeholder="{{ 'find_connector' | translate }}..."
            data-cy="med_connectors_search_input"
            [(ngModel)]="connectorFilter"
          />
          <span class="input-group-text border-0">
            <div class="med_empty-button d-flex justify-content-center align-items-center rounded-end-3 border-0">
              @if (connectorFilter) {
                <app-icon icon="xmark" (click)="clearConnectorFilter()" class="cursor-pointer"> </app-icon>
              }
            </div>
          </span>
        </div>
        <button
          mat-icon-button
          aria-label="more menu"
          class="med_more-menu-btn border-0"
          [matMenuTriggerFor]="menu"
          data-cy="med_connectors_more_options_btn"
        >
          <app-icon icon="ellipsis-vertical" />
        </button>
        <mat-menu #menu="matMenu">
          <div class="three-dots-menu">
            <button mat-menu-item (click)="toggleAllConnectors('enable')" data-cy="med_enable_all_connectors_btn">
              <app-icon icon="power-on" class="icon-active" /><span class="l-body">{{
                "enable_all_connectors" | translate
              }}</span>
            </button>
            <button mat-menu-item (click)="toggleAllConnectors('disable')">
              <app-icon icon="no-plug" class="icon-active" /><span class="l-body">{{
                "disable_all_connectors" | translate
              }}</span>
            </button>
          </div>
        </mat-menu>
      </div>
    }
    <!-- #DESKTOP MENU -->

    <!-- MOBILE MENU -->
    @if (!deviceType.isDesktop) {
      <div class="d-flex justify-content-end align-items-center">
        <button class="med_sort-btn-mobile border-0" mat-button [matMenuTriggerFor]="belowMenu">
          <app-icon icon="filter" class="icon-active"></app-icon>
        </button>
        <mat-menu
          #belowMenu="matMenu"
          yPosition="below"
          class="med_filter-drowpdown d-flex flex-column align-itmes-start mt-1"
        >
          @for (option of myAppsStore.connectorFilterMenu(); let i = $index; track $index) {
            <button mat-menu-item (click)="toggleConnectorFilter(option.name)" [ngClass]="{ active: option.checked }">
              <span class="l-body">{{ option.label }}</span>
              <span class="xs-body secondary-color ps-1 text-nowrap"
                >{{ myAppsStore.getSelectedFilterCount(option.name) }} / {{ myAppsStore.allConnectors().length }}</span
              >
            </button>
          }
        </mat-menu>

        @if (searchVisible) {
          <div
            class="med_m-search d-flex justify-content-between align-items-center position-absolute ps-3 top-0 end-0 bottom-0 start-0"
          >
            <div class="input-group med_search">
              <span class="input-group-text">
                <app-icon icon="magnifying-glass" />
              </span>
              <input
                type="text"
                class="form-control"
                placeholder="{{ 'find_connector' | translate }}..."
                [(ngModel)]="connectorFilter"
              />
            </div>
            <button class="btn btn-link" (click)="clearConnectorFilter()">
              <app-icon icon="xmark" />
            </button>
          </div>
        }
        <button mat-icon-button aria-label="more menu" class="med_more-menu-btn border-0" [matMenuTriggerFor]="menu">
          <app-icon icon="ellipsis-vertical" />
        </button>
        <mat-menu #menu="matMenu">
          <div class="three-dots-menu">
            <button mat-menu-item (click)="showSearch()">
              <app-icon icon="magnifying-glass" class="icon-active" /><span>{{ "search_connectors" | translate }}</span>
            </button>
            <button mat-menu-item (click)="toggleAllConnectors('enable')">
              <app-icon icon="power-on" class="icon-active" /><span>{{ "enable_all_connectors" | translate }}</span>
            </button>
            <button mat-menu-item (click)="toggleAllConnectors('disable')">
              <app-icon icon="no-plug" class="icon-active" /><span>{{ "disable_all_connectors" | translate }}</span>
            </button>
          </div>
        </mat-menu>
      </div>
    }
    <!-- #MOBILE MENU -->
  </ng-container>
</app-header-bar>

<!-- Grid view -->
@if (
  !isListView &&
  ((myAppsStore.connectedFilteredConnectors().length > 0 &&
    ((myAppsStore.connectedFilteredConnectors() | filterOptions: ["name", "parentName"] : connectorFilter) || [])
      .length > 0) ||
    (myAppsStore.disconnectedFilteredConnectors().length > 0 &&
      ((myAppsStore.disconnectedFilteredConnectors() | filterOptions: ["name", "parentName"] : connectorFilter) || [])
        .length > 0))
) {
  <div
    [ngClass]="{ 'med_hidden-connector': loading }"
    class="med_connectors-list-wrapper overflow-y-auto overflow-x-hidden"
    data-cy="med_connectors_list_wrapper"
    [ngClass]="{ 'med_connectors-list-wrapper-mobile': !deviceType.isDesktop }"
  >
    @if (
      myAppsStore.connectedFilteredConnectors().length > 0 &&
      !loading &&
      ((myAppsStore.connectedFilteredConnectors() | filterOptions: ["name", "parentName"] : connectorFilter) || [])
        .length > 0
    ) {
      <div class="title-wrapper d-flex flex-column gap-2 mb-3">
        <h2 class="xs-title bold">{{ "apps_in_use" | translate }}</h2>
        <span class="xl-body"> {{ "app_enabled_description" | translate }} </span>
      </div>
    }
    <!-- Connected connectors -->
    <ngx-masonry
      class="med_masonrry"
      [ngClass]="{ med_masonrry_mobile: !deviceType.isDesktop }"
      [options]="mansoryOptions"
      #connectedMasonryContainer
      [ordered]="true"
    >
      @for (
        connector of myAppsStore.connectedFilteredConnectors()
          | filterOptions: ["name", "parentName"] : connectorFilter;
        track connector.uuid;
        let i = $index
      ) {
        <ng-container>
          <div ngxMasonryItem class="med_masonry-item mb-3" [style.width.px]="masonryCardWidth" #connectorCardConnected>
            <app-connector-card
              class="connector-card"
              [ngClass]="{ 'med_hidden-connector': loading }"
              [connectorIndex]="i"
              [connector]="connector"
              [processing]="myAppsStore.processing()"
              [connectorUpdatedUuid]="myAppsStore.connectorUpdatedUuid()"
              [isListView]="false"
              (onLogoutConnector)="logoutConnector(connector)"
              (onGoToLogin)="gotoConnectorLogin(connector)"
              (onToggleSwitch)="toggleSwitch(connector)"
              (onToggleSwitchSubconnector)="toggleSwitch($event)"
              (onInitAnimationSubconnectorsList)="refreshRepeating()"
            >
            </app-connector-card>
          </div>
        </ng-container>
      }
    </ngx-masonry>
    <!-- #Connected connectors -->

    <!-- Not connected connectors -->
    @if (
      myAppsStore.disconnectedFilteredConnectors().length > 0 &&
      !loading &&
      ((myAppsStore.disconnectedFilteredConnectors() | filterOptions: ["name", "parentName"] : connectorFilter) || [])
        .length > 0
    ) {
      <div class="title-wrapper d-flex flex-column gap-2 mb-3">
        <h2 class="xs-title bold">{{ "apps_not_enabled" | translate }}</h2>
        <span class="xl-body"> {{ "apps_not_enabled_description" | translate }} </span>
      </div>
    }
    <ngx-masonry
      [options]="mansoryOptions"
      [ngClass]="{ med_masonrry_mobile: !deviceType.isDesktop }"
      #notConnectedMasonryContainer
      [updateLayout]="true"
      [ordered]="true"
      class="med_masonrry med_not-active-grid"
    >
      @for (
        connector of myAppsStore.disconnectedFilteredConnectors()
          | filterOptions: ["name", "parentName"] : connectorFilter;
        track connector.uuid;
        let i = $index
      ) {
        <div
          ngxMasonryItem
          class="med_masonry-item mb-3"
          [style.width.px]="masonryCardWidth"
          #connectorCardDisconnected
        >
          <app-connector-card
            class="connector-card"
            [ngClass]="{ 'med_hidden-connector': loading }"
            [connectorIndex]="i"
            [connector]="connector"
            [processing]="myAppsStore.processing()"
            [connectorUpdatedUuid]="myAppsStore.connectorUpdatedUuid()"
            [isListView]="false"
            (onLogoutConnector)="logoutConnector(connector)"
            (onGoToLogin)="gotoConnectorLogin(connector)"
            (onToggleSwitch)="toggleSwitch(connector)"
            (onToggleSwitchSubconnector)="toggleSwitch($event)"
            (onInitAnimationSubconnectorsList)="refreshRepeating()"
          >
          </app-connector-card>
        </div>
      }
    </ngx-masonry>
    <!-- #Not connected connectors -->

    <!-- All apps link card -->
    @if (
      ((myAppsStore.connectedFilteredConnectors().length || myAppsStore.disconnectedFilteredConnectors().length) &&
        userService.companySubscription() === null) ||
      userService.companySubscription()?.id === undefined
    ) {
      <div
        class="med_see-all-apps-wrapper d-flex justify-content-center align-items-center flex-wrap mb-4 px-4 py-3 gap-2"
      >
        <h3 class="xs-title bold m-0">{{ "all_app_count" | translate }}</h3>
        <p class="m-0">{{ "all_connectors_text" | translate }}</p>
        <button
          (click)="gotoAllConnectors()"
          class="med_btn-rainbow d-flex justify-content-center align-items-center rounded-pill"
        >
          <p class="m-0 p-0 d-flex justify-content-center align-items-center w-100">
            {{ "discover_all_apps" | translate }}
          </p>
        </button>
      </div>
    }
    <!-- All apps link card -->
  </div>
} @else if (!isListView && !loading) {
  <div class="med_no-results h-100 d-flex flex-column justify-content-center align-items-center gap-2">
    <img src="assets/images/no-apps.png" alt="No apps" class="mb-3" loading="lazy" />
    <h2 class="l-title bold">{{ "no_apps_found" | translate }}</h2>
    <p class="l-body">{{ "no_apps_found_description" | translate }}</p>
  </div>
}

<!-- #Grid view -->
